import { Button } from '@metservicedev/met-ui';
import React from 'react';

import { useAppConfig } from '../context/AppConfigProvider';
import { createStyles } from '../tss';
import { TermsOfUseDialog } from './TermsOfUseDialog';

const useStyles = createStyles(({ theme }) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(1),
    color: theme.color.text.default,
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
    whiteSpace: 'nowrap',
  },
  termsButton: {
    background: 'none',
    height: 'unset',
    minWidth: 'unset',
    padding: 0,
    paddingInline: '0 !important',
    fontSize: 'inherit',
    lineHeight: 'inherit',
    outline: 'none',
    border: 'none',
    color: 'inherit',
    fontWeight: 'inherit',
  },
}));

export const PortalInfo: React.FC = () => {
  const { classes } = useStyles();
  const config = useAppConfig();
  const [showTerms, setShowTerms] = React.useState(false);

  return (
    <div className={classes.root}>
      <TermsOfUseDialog onClose={() => setShowTerms(false)} open={showTerms} />
      <Button
        className={classes.termsButton}
        data-testid="button-show-terms"
        onClick={() => setShowTerms(true)}
        style={{ paddingInline: 'unset !important' }}
        variant="tertiary"
      >
        Terms of Use
      </Button>
      <span> | </span>
      <span>Portal Version: {config.version}</span>
    </div>
  );
};
